module.exports = __webpack_public_path__ + "img/Account-Transaction-Bundled-Gradient.31a09e46.svg";